import React, { FC, useCallback, useEffect, useState, useContext, useRef } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';
import { get, post } from "../fetchers/fetchers";
import { get_query } from '../stateManagement/data';

import { API_URL } from "../env";

import { useParams } from "react-router";

import {
    Accordion, AccordionDetails, AccordionSummary,
    Container, Grid, IconButton, Paper,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
    withStyles
} from "@material-ui/core";
import {
    IAdequacy,
    IControlMeasure, IControlMeasureAssessment,
    IControlMeasureFailureMode,
    IControlType, IFailureModeAssessment, IHarm,
    IProjectFailureMode,
    IRiskAssessment
} from "../types/types";
import ControlMeasureAssessment from "./control_measure_assessment";
import control_measure_assessment from "./control_measure_assessment";
import AddIcon from "@material-ui/icons/Add";
import AdditionalControlMeasureAssessment from "./additional_control_measure_assessment";
import { ExpandMore } from "@material-ui/icons";
import ControlMeasures from "./control_measuers";

import {getFailureModeControlMeasures, getControlMeasureAssessment} from "../stateManagement/data";
import { add } from 'date-fns';

// import ControlMeasure from "./control_measure";

interface IControlMeasureAssessmentsProps {
    existing: boolean,
    considered: boolean
}

interface IRouteParams {
    id: string
}



const ControlMeasureAssessments: FC<IControlMeasureAssessmentsProps> = ({ existing, considered }) => {

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()

    // console.log(tasks.loaded)

    const [isLoaded, setIsLoaded] = useState<boolean>(true);
    const [controlTypes, setControlTypes] = useState<IControlType[]>([]);
    const [controlMeasures, setControlMeasures] = useState<IControlMeasure[]>([]);
    const [adequacies, setAdequacies] = useState<IAdequacy[]>([]);
    const [failureModes, setFailureModes] = useState<IProjectFailureMode[]>([]);
    const [controlMeasureAssessments, setControlMeasureAssessments] = useState<IControlMeasureAssessment[]>([]);
    const [controlMeasureFailureModes, setControlMeasureFailureModes] = useState<IControlMeasureFailureMode[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [failureModeAssessments, setFailureModeAssessments] = useState<IFailureModeAssessment[]>([]);

    useEffect(() => {

        if (tasks.loaded) {


            setControlMeasures(tasks.controlMeasures)
            setFailureModes(tasks.failureModes)
            setControlMeasureFailureModes(tasks.failureModeControlMeasures)
            setFailureModeAssessments(tasks.failureModeAssessments)
            setAdequacies(tasks.adequacies)
            setControlTypes(tasks.controlTypes)
            setControlMeasureAssessments(tasks.controlMeasureAssessments)

        }

    },[tasks])

    const params = useParams<IRouteParams>()

    const setControlMeasureAssessment = async (controlMeasureAssessment: IControlMeasureAssessment) => {
        delete controlMeasureAssessment.id

        let d = await post<IControlMeasureAssessment>(API_URL + "control_measures/" + params.id.toString() + "/assessments", controlMeasureAssessment);
        let e = getControlMeasureAssessment(params.id, dispatch)
    }

    const getCMeasureAssessment = (cm: IControlMeasure, cf: IProjectFailureMode): IControlMeasureAssessment => {
        if (!cf.id) {
            throw new Error("Project Failure Mode id is not defined")
        }

        let cm_id = cm.uuid
        if (!cm_id)
            cm_id = -1
        let controlMeasureAssessment = controlMeasureAssessments.find(
            cma =>
                cma.control_measure_id === cm_id &&
                cma.project_failure_mode_id === cf.id
        )

        if (controlMeasureAssessment) {
            return controlMeasureAssessment
        }
        if (!cf.id) {

        }
        controlMeasureAssessment = {
            control_measure_id: cm_id,
            project_failure_mode_id: cf.id
        }
        return controlMeasureAssessment
    }

    const render_category = (index: number, f: IProjectFailureMode) => {
        return (
            
            <Accordion style={{ backgroundColor: "#f3f3f3" }} square>
                <AccordionSummary id={f.id?.toString()} expandIcon={<ExpandMore />}>
                    <Typography variant="h6"> {f.failure_mode?.name} </Typography>
                </AccordionSummary>
    
                {/* add container */}

                <p style={{ position: 'sticky', top: 67, zIndex: 10, paddingLeft: 15, backgroundColor: "#f3f3f3", textAlign: "left" }}>
                    <b>{f.failure_mode?.name}</b> 
                </p>
                
                <Table>
                    
                    <TableHead  style={{ position: 'sticky', top: 70, zIndex: 2, backgroundColor: "#f3f3f3" }}>
                        <TableCell>Control Measures</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell width={"40%"}>Assessment</TableCell>
                        {existing &&
                            <TableCell>Comparison to Good Practice</TableCell>
                        }
                        {!existing &&
                            <>
                                <TableCell>De Minimis</TableCell>
                                <TableCell>Good Practice</TableCell>
                                <TableCell>Practicable</TableCell>
                                <TableCell>Effective</TableCell>
                                <TableCell>Take Forward</TableCell>
                            </>
                        }
                        <TableCell>Comments</TableCell>
                    </TableHead>

                    {render_control_measure_assessment(f)}
                </Table>
            </Accordion>
        )
    }



    const render_control_measure_assessment = (f: IProjectFailureMode) => {

        return controlMeasureFailureModes.filter((cf) => cf.project_failure_mode_id === f.id && cf.priority > 0).sort((a, b) => {
            let cm_a = controlMeasures.filter((c) => c.existing === existing).find(c => c.uuid === a.control_measure_id)
            let cm_b = controlMeasures.filter((c) => c.existing === existing).find(c => c.uuid === b.control_measure_id)
            return  (cm_a?.order || 1000000)  - (cm_b?.order || 1000000);

        }   
        ).map((cf) => {
                let cm = controlMeasures.filter((c) => c.existing === existing).find(
                    c => c.uuid === cf.control_measure_id
                )

                if (!cm) {
                    return <></>
                }

                if (existing) {
                    return (
                        <ControlMeasureAssessment control_types={controlTypes}
                            failure_mode={f}
                            control_measure={cm}
                            control_measure_assessment={getCMeasureAssessment(cm, f)}
                            updateControlMeasuresAssessment={setControlMeasureAssessment}
                            adequacies={adequacies}
                        />
                    )
                }
                return (
                    <AdditionalControlMeasureAssessment control_types={controlTypes}
                        failure_mode={f}
                        control_measure={cm}
                        control_measure_assessment={getCMeasureAssessment(cm, f)}
                        updateControlMeasuresAssessment={setControlMeasureAssessment}
                        adequacies={adequacies}
                    />
                )

            })
    }

    return (

        <Grid container xs={12} lg={12} style={{ padding: 10, width: "100%" }}>

            <Paper variant={"outlined"}

                style={{ display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1 }}>
                {isLoaded && failureModes.map((f, index) => {
                    if (f.failure_mode?.is_active === false) { return <></> }
                    let fma = failureModeAssessments.find(fma => fma.project_failure_mode_id === f.id)
                    if (!fma) { return <></> }

                    if (fma.consider === considered) {
                        return render_category(index + 1, f)
                    } else if (fma.consider === null && !considered) {
                        return render_category(index + 1, f)

                    }
                    
                    else {

                        return <></>
                    }

                })}
                <div>
                    <Typography><small>Note only included group failure modes are shown</small></Typography>
                </div>
            </Paper>
        </Grid>




    );
}

export default ControlMeasureAssessments;

